import { render, staticRenderFns } from "./EmailModel.vue?vue&type=template&id=60ef1ada&scoped=true"
import script from "./EmailModel.vue?vue&type=script&lang=js"
export * from "./EmailModel.vue?vue&type=script&lang=js"
import style0 from "./EmailModel.vue?vue&type=style&index=0&id=60ef1ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef1ada",
  null
  
)

export default component.exports